import { date } from "yup";

export interface AyudanteInvInfo{
    idproyecto: number;
    idayudantiaproyecto: number;
    iddetallesolicitud: number;
    idsolicitudayudantia: number;
    tipo: string;
    nombreEstudiante: string;
    anio: string;
    termino: string;
    descripcion: string;
    actividades: string;
    tipoFinanciamiento: number;
    emailResponsable: string;
    comentario: string;
    estadoDelegado: string;
    estadoSubdecano: string;
    estadoVicerrectorado: string;
    idPeriodo : number;
    codestudiante : string;
    financiamientoTexto: string;
    fechasolicitud: Date;
    horas : number;
    estadoPaso: string;
    horasOtorgadas: number;
}

export function voidSolicitudAyudanteInv() : AyudanteInvInfo {
    const fechaNula = new Date(1, 0, 1);
    return{
        idproyecto: 0,
        idayudantiaproyecto: 0,
        iddetallesolicitud: 0,
        idsolicitudayudantia: 0,
        tipo: "",
        nombreEstudiante: "",
        anio: "",
        termino: "",
        descripcion: "",
        actividades: "",
        tipoFinanciamiento: 0,
        emailResponsable: "",
        comentario: "",
        estadoDelegado: "",
        estadoSubdecano: "",
        estadoVicerrectorado: "",
        idPeriodo : 0,
        codestudiante : "",
        financiamientoTexto: "",
        fechasolicitud: fechaNula,
        horas: 0,
        estadoPaso  :"",
        horasOtorgadas : 0
    }
    
}
 export function setSolicitudAyud(data: any): AyudanteInvInfo {
    const fechaNula = new Date(1, 0, 1);
    return {
        idproyecto: data.idproyecto ?? 0,
        idayudantiaproyecto: data.idayudantiaproyecto ?? 0,
        iddetallesolicitud: data.iddetallesolicitud ?? 0,
        idsolicitudayudantia: data.idsolicitudayudantia ?? 0,
        tipo: data.tipo ?? "",
        nombreEstudiante: data.nombreEstudiante ?? "",
        anio: data.anio ?? "",
        termino: data.termino ?? "",
        descripcion: data.descripcion ?? "",
        actividades: data.actividades ?? "",
        tipoFinanciamiento: data.tipoFinanciamiento ?? 0,
        emailResponsable: data.emailResponsable ?? "",
        comentario: data.comentario ?? "",
        estadoDelegado: data.estadoDelegado ?? "",
        estadoSubdecano: data.estadoSubdecano ?? "",
        estadoVicerrectorado: data.estadoVicerrectorado ?? "",
        idPeriodo : data.idPeriodo ?? 0,
        codestudiante : data.codEstudiante ?? "",
        financiamientoTexto: data.financiamientoTexto ?? "",
        fechasolicitud: data.fechaSolicitud ??  fechaNula,
        horas: data.horas ?? 0,
        estadoPaso  : data.estadoPaso ?? "",
        horasOtorgadas : data.horasOtorgadas ?? 0
      
    };
  }